import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import ReactTooltip from 'react-tooltip';
import { Stack, Inline, Text, textVariants } from '@etg/wings';
import { useEffect, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const genericStyles = css`
  min-width: 240px;
  /* stylelint-disable-next-line declaration-no-important */
  padding: 16px !important;
`;
const inlineStyles = css`
  justify-content: space-between;
`;
const SeatToolTipWithPriceBreakdown = _ref => {
  var _markup$value;
  let {
    carrier,
    id,
    markup,
    price,
    seat
  } = _ref;
  const {
    t
  } = useTranslation();
  const [seatId, setSeatId] = useState('');
  useEffect(() => {
    setSeatId(id);
  }, [id]);
  const labels = {
    seat: t('OrderDetails.Passenger.Drawer.Seat.Title'),
    markup: t('Product.Markup.Label')
  };
  const normalizedMarkup = typeof markup === 'number' ? markup : (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : 0;
  return /*#__PURE__*/_jsx(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    effect: "solid",
    globalEventOff: "touchstart",
    id: id,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: `${labels.seat}: ${seat}`
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: priceUtil.formatPrice(price)
        })]
      }), carrier && /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: carrier.name
        }), /*#__PURE__*/_jsx(Text, {
          children: priceUtil.formatPrice(price - normalizedMarkup)
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: labels.markup
        }), /*#__PURE__*/_jsx(Text, {
          children: priceUtil.formatPrice(normalizedMarkup)
        })]
      })]
    })
  }, `key-${seatId}`);
};
export default SeatToolTipWithPriceBreakdown;
//# sourceMappingURL=SeatTooltipWithPriceBreakdown.js.map